import { Route } from '@angular/router';
import { EmployeesListComponent } from './ui/employees-list/employees-list.component';
import { employeeManagerGuard } from '../../core/guards/employee-manager.guard';

const employeesRoutes: Route[] = [
  {
    path: 'employees',
    component: EmployeesListComponent,
    canActivate: [employeeManagerGuard],
  },
];

export default employeesRoutes;
